import UploadFile from './UploadFile.view';
export default UploadFile;
